import { render, staticRenderFns } from "./MensagensComunicado.vue?vue&type=template&id=76058627&scoped=true&lang=pug&"
import script from "./MensagensComunicado.vue?vue&type=script&lang=js&"
export * from "./MensagensComunicado.vue?vue&type=script&lang=js&"
import style0 from "./MensagensComunicado.vue?vue&type=style&index=0&id=76058627&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76058627",
  null
  
)

export default component.exports